import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Result as AntResult, Avatar, Button, Space } from "antd";
import PropTypes from "prop-types";

import { TextField } from "misc/fields";
import { StackIcon } from "misc/icons";
import { stsColors } from "styles";

const Result = ({ type, url, ...props }) => {
    switch (type) {
        case "roleExpired":
            return (
                <AntResult
                    title={<TextField value="t_result_title_role_expired" />}
                    subTitle={<TextField value="t_result_sub_title_role_expired" />}
                    icon={
                        <Avatar
                            size={70}
                            icon={
                                <StackIcon>
                                    <FontAwesomeIcon icon={["fas", "money-check-pen"]} />
                                    <FontAwesomeIcon icon={["fas", "slash"]} color={stsColors.blue} style={{ position: "absolute", top: "6px" }} />
                                    <FontAwesomeIcon icon={["fas", "slash"]} />
                                </StackIcon>
                            }
                        />
                    }
                />
            );
        case "unauthorizedAccess":
            return (
                <AntResult
                    title={<TextField value="t_result_title_unauthorized_access" />}
                    subTitle={<TextField value="t_result_sub_title_unauthorized_access" />}
                    icon={<FontAwesomeIcon size="4x" icon={["fas", "user-lock"]} />}
                />
            );

        default:
            return <AntResult {...props} />;
    }
};

Result.propTypes = {
    type: PropTypes.string.isRequired,
    url: PropTypes.string
};

export default Result;
